import { compose, values, pickAll } from 'ramda'
import pluralize from 'pluralize'

export const pause = async (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const delay = async (fn, ms) => {
	await pause(ms)
	await fn()
}

export const pickByIndex = compose(values, pickAll)


pluralize.addPluralRule(/this$/i, 'these')
pluralize.addSingularRule(/these$/i, 'this')
export const plural = pluralize